<template>
    <div class="prices-options-block shippingOptionCode_input">
        <div class="price-top-label" v-if="!isEdit">
            <div class="price-option-column">{{ $helper.trans('Service') }}</div>
            <div class="price-option-column">{{ $helper.trans('Time') }}</div>
            <div class="price-option-column">{{ $helper.trans('Price') }}</div>
        </div>
        <div class="price-option-line justify-content-center align-items-center" v-if="loading">
            {{ $helper.trans('Search_for_services') }}
            <i class="fa fa-cog fa-spin fa-2x ml-2"></i>
        </div>
        <div class="price-option-line justify-content-center align-items-center" v-if="!loading && !reset && $store.state.availableShippingOptions.length === 0">
            {{ $helper.trans(currentError) }}
        </div>
        <div 
            class="price-option-line justify-content-center align-items-center" 
            style="color: rgba(231, 76, 60, 0.88);" 
            v-if="$store.state.selectShippingOption"
        >{{ $helper.trans('Please_select_again_ups_service') }}</div>
        <div class="price-option-line justify-content-center align-items-center text-center" v-if="!loading && isEdit && $store.state.availableShippingOptions.length === 0 && reset">
            <div class="price-option-column price-value-column">
                <button class="btn btn-yellow radius-4" @click="getSearchOptions();">{{ $helper.trans('Search') }}</button>
            </div>
        </div>
        <div class="price-option-line" 
            v-for="(shipment, shipmentIndex) in $store.state.availableShippingOptions" 
            :key="shipmentIndex"
            :class="{'selected-shipping-option': $store.state.selectedShippingOption.serviceCode === shipment.serviceCode}"
        >
            <div class="price-option-column">
                <div class="price-content">
                    <h3 class="price-option-title">{{ shipment.serviceName }}</h3>
                    <span class="price-delivery-time">{{ $helper.trans('Latest_collection_time') }}:</span>
                    <span class="price-delivery-date" style="text-transform:capitalize;" v-html="formattedEstimatedPickup(shipment)"></span>
                    <span class="price-delivery-time" v-if="!isImport">{{ $helper.trans('Order_until') }}: {{ shipment.orderUntil }} {{ $helper.trans('Hr') }}</span>
                </div>
            </div>
            <div class="price-option-column">
                <div class="price-content">
                    <span class="price-delivery-time">{{ $helper.trans('Estimated_delivery') }}:</span>
                    <span class="price-delivery-date" v-html="formattedEstimatedDelivery(shipment)"></span>
                    <span v-show="shipment.guaranteed" class="price-delivery-guarantee">{{ $helper.trans('With_warranty') }}
                        <i class="fa fa-question-circle info-question-circle position-absolute" style="top: 5px;">
                            <div class="custom-popover-wrapper">
                                <div class="custom-popover alert alert-secondary" v-html="$helper.trans('Guaranteed_indicator_info')"></div>
                            </div>
                        </i>
                    </span>                    
                </div>
            </div>
            <div class="price-option-column price-value-column">
                <div class="price-content">
                    <div class="price-value-with-vat">
                        <div class="without-vat">{{ shipment.total_without_vat }} €</div>
                        <div class="total-container">
                            <div class="vat">+{{ $helper.trans('VAT') }} {{ shipment.vat * 100 }}%</div>
                            <div class="total">({{ shipment.total }} €)</div>
                        </div>
                    </div>
                    <button type="button" @click="selectShippingOption(shipment);" class="btn btn-yellow radius-4" v-if="!customCalculator">{{ initialSelect ?  $helper.trans('Order_now') : $helper.trans('Select') }}</button>

                    <button type="button" @click="selectCustomShippingOption(shipment);" class="btn btn-yellow radius-4" v-if="customCalculator">{{ $helper.trans('Select') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from "../../../store";
export default {
    store,
    data: function(){
        return {
            loading: false,
            reset: false,
            currentError: 'SO_ERROR_No_available_services',
        };
    },
    props:{
        isEdit:{
            type: Boolean,
            required: false,
            default: false,
        },
        initialSelect:{
            type: Boolean,
            required: false,
            default: false,
        },
        customCalculator:{
            type: Boolean,
            required: false,
            default: false,
        }
    },
    created: function(){
        this.$store.state.awaitingActions.shippingOptionsWereReset = false;
        
        if(this.$store.state.availableShippingOptions.length > 0 || this.$store.state.inClientAdmin){
            return;
        }

        this.getSearchOptions();
    },
    methods:{
        selectShippingOption: function(shippingOption, stay=false) {
            this.$store.state.selectedShippingOption = shippingOption;
            this.$store.state.checkOutSteps.second = false;
            this.$store.state.selectShippingOption = false;

            if (moment(shippingOption.estimatedDelivery).weekday() == 6 && this.$store.state.selectedShippingOption.isSaturdayDeliveryAvailable) {
                this.$store.state.otherDeliveryInformation.saturdayDelivery = true;
            }

            if (stay) {
                return;
            }
            
            if (!this.$store.state.checkOutSteps.second) {                              
                this.$helper.pushDataLayer(2, shippingOption);  
                this.$store.state.checkOutSteps.second = true;
            }

            if (this.isEdit) {
                this.$store.state.currentActions.editingPackages = false;
                return;
            } else {
                this.$emit('optionSelected');
            }
        },
        selectCustomShippingOption: function(shippingOption, stay=false){
            this.$store.state.selectedShippingOption = shippingOption;
            this.$emit('optionSelected');
        },
        getSearchOptions: async function(){
            let vueThis = this;

            vueThis.loading = true;

            // NOTE Set Malta city
            if(vueThis.$store.state.from.country === 'mt'){
                vueThis.$store.state.shipperAddressInformation.city = vueThis.$helper.getMaltaCity(vueThis.$store.state.from.postCode);
            }
            if(vueThis.$store.state.to.country === 'mt'){
                vueThis.$store.state.deliveryAddressInformation.city = vueThis.$helper.getMaltaCity(vueThis.$store.state.to.postCode);
            }

            if (!vueThis.$store.state.inClientAdmin) {
                if (vueThis.$store.state.from.country === 'ma') {
                    vueThis.$store.state.from.postCode = vueThis.$helper.getMoroccoPostCode(vueThis.$store.state.shipperAddressInformation.city);
                }
                if (vueThis.$store.state.to.country === 'ma') {
                    vueThis.$store.state.to.postCode = vueThis.$helper.getMoroccoPostCode(vueThis.$store.state.deliveryAddressInformation.city);
                }
            }

            let customDiscounts = [];
            if (vueThis.customCalculator) {
                customDiscounts = {
                    transportation: vueThis.$store.state.manualDiscounts.transportation,
                    privateAddress: vueThis.$store.state.manualDiscounts.privateAddress,
                    extendedArea: vueThis.$store.state.manualDiscounts.extendedArea,
                    additionalHandling: vueThis.$store.state.manualDiscounts.additionalHandling,
                };
            }

            let url = vueThis.$store.state.$routes['api.get_shipping_options_json'];
            let data = {
                from: {
                    country: vueThis.$store.state.from.country,
                    postCode: vueThis.$store.state.from.postCode,
                    city: vueThis.$store.state.shipperAddressInformation.city,
                },
                to: {
                    country: vueThis.$store.state.to.country,
                    postCode: vueThis.$store.state.to.postCode,
                    city: vueThis.$store.state.deliveryAddressInformation.city,
                },      

                clientId: vueThis.customCalculator ? vueThis.$store.state.clientId : null,
                customDiscounts,
                packageType: vueThis.$store.state.packageType,
                packages: vueThis.$store.state.packagesDimensions
            };   

            if (vueThis.$store.state.loggedInUser) {
                let additionalData = {
                    shipperAddressInformation: vueThis.$store.state.shipperAddressInformation,
                    deliveryAddressInformation: vueThis.$store.state.deliveryAddressInformation,
                };

                data = Object.assign({}, data, additionalData);
            }            
            
            await axios.post(url, data, {
                headers: {
                    'Content-Type': 'application/json',
                },
            }).then(function(response) {
                vueThis.currentError = response.data.error;
                vueThis.$store.state.availableShippingOptions = response.data.rates;

                if (vueThis.customCalculator) {
                    vueThis.$store.state.temporaryDetailedCosts = response.data.detailed_costs;
                }

                if(!empty(vueThis.$store.state.userSettings.default_main_service) && !vueThis.$store.state.copied){
                    $.each(vueThis.$store.state.availableShippingOptions, function (index, option) {
                        if(option.serviceCode === vueThis.$store.state.userSettings.default_main_service){
                            vueThis.selectShippingOption(option, true);
                            return false;
                        }
                    });
                }
      
                vueThis.$store.state.availableShippingOptions = response.data.rates;
                vueThis.$store.state.additionalAddressInfo = response.data.additionalAddressInfo;
                if(vueThis.$store.state.inClientAdmin){
                    return;
                }

                if(vueThis.$store.state.additionalAddressInfo.from !== undefined && vueThis.$store.state.additionalAddressInfo.from.length > 0){
                    if(vueThis.$store.state.additionalAddressInfo.from.length === 1){
                        vueThis.$store.state.shipperAddressInformation.city = vueThis.$store.state.additionalAddressInfo.from[0].city;
                    }
                    vueThis.$store.state.shipperAddressInformation.stateOrProvince = vueThis.$store.state.additionalAddressInfo.from[0].state.toLowerCase();
                    vueThis.$store.state.awaitingActions.refreshStateOrProvince.shipperAddressInformation = true;
                }
                if(vueThis.$store.state.additionalAddressInfo.to !== undefined && vueThis.$store.state.additionalAddressInfo.to.length > 0){
                    if(vueThis.$store.state.additionalAddressInfo.to.length === 1){
                        vueThis.$store.state.deliveryAddressInformation.city = vueThis.$store.state.additionalAddressInfo.to[0].city;
                    }
                    vueThis.$store.state.deliveryAddressInformation.stateOrProvince = vueThis.$store.state.additionalAddressInfo.to[0].state.toLowerCase();
                    vueThis.$store.state.awaitingActions.refreshStateOrProvince.deliveryAddressInformation = true;
                }
            }).catch(function(error){
                if(error.response.status == 422){
                    console.table(error.response.data.errors);
                    alert('Formoje yra klaidų');
                }
            }).finally(function(){
                vueThis.loading = false;
                if(vueThis.isEdit || vueThis.$store.state.inClientAdmin){
                    vueThis.reset = false;
                }
                vueThis.$store.state.currentActions.gettingShippingOptions = false;
            });
        },
        formattedEstimatedDelivery(shipment){
            let time = moment(shipment.estimatedDelivery).locale(this.$store.state.$siteSettings['current_lang']);
            time = time.format(`dddd L[,<br>${this.$helper.trans('until')}] LT`);
            time = time.charAt(0).toUpperCase() + time.slice(1);
            return time.replace('23:30', this.$helper.trans('end_of_work'));
        },
        formattedEstimatedPickup(shipment){
            let time = moment(shipment.estimatedPickup).locale(this.$store.state.$siteSettings['current_lang']);
            return time.format(`dddd L[,<br>${this.$helper.trans('until')}] LT`);
        },
        isImport(){
            return this.$store.state.to.country === 'lt';
        }
    },
    watch:{
        '$store.state.awaitingActions.shippingOptionsWereReset': function(){
            let val = this.$store.state.awaitingActions.shippingOptionsWereReset;
            this.$store.state.awaitingActions.shippingOptionsWereReset = false;
            if(val === false || (!this.isEdit && !this.$store.state.inClientAdmin)){
                return;
            }
            this.reset = true;
        },
        '$store.state.awaitingActions.getSearchOptions': async function(){
            let val = this.$store.state.awaitingActions.getSearchOptions;
            this.$store.state.awaitingActions.getSearchOptions = false;
            if(val === false){
                return;
            }

            if(this.reset || this.$store.state.currentActions.gettingShippingOptions){
                this.$store.state.availableShippingOptions = [];
                await this.getSearchOptions();
            }
        },
        '$store.state.awaitingActions.selectNewOption': async function(){
            let newSelectedOption = this.$store.state.awaitingActions.selectNewOption;
            let vueThis = this;
            if(newSelectedOption === false){
                return;
            }
                
            vueThis.$store.state.awaitingActions.selectNewOption = false;
            vueThis.$store.state.availableShippingOptions = [];
            
            await this.getSearchOptions();

            let hasSameService = false;
            
            $.each(this.$store.state.availableShippingOptions, function (index, option) {                 
                if (option.serviceCode === newSelectedOption) {
                    hasSameService = true;
                    vueThis.selectShippingOption(option, true); 
                    return true;
                }
            });          
            
            if (!hasSameService) {
                vueThis.$store.state.awaitingActions.hasSameService = false;
            }
            
        },
    }
};
</script>
